import { useEffect, useState } from 'react';
import { EMPTY_ARRAY, EMPTY_STRING, ZERO } from '../utils/common';

/**
 * 
 * @param {Array[Arrays]} records : [[1,2,3], [2,4,5]]
 * @param {Object(term, colsToSearch)} search : [[1,2,3], [2,4,5]]
 * @returns 
 */
export const useDataFilter = ({ records = EMPTY_ARRAY,
  searchCols = EMPTY_ARRAY,
  searchTerm = EMPTY_STRING,
  orderCol = ZERO,
  order,
  forceUpdate
}) => {
  const [state, setState] = useState({ filteredData: records, updated: 0 })
  useEffect(() => {
    setState(s => ({ filteredData: records, updated: s.updated + 1 }));
  }, [records?.length, forceUpdate])

  useEffect(() => {
    setState(s => (
      {
        filteredData: records.filter(v => {
          let containsFilterTerm = false;
          searchCols.map(i => {
            if (String(v[i]).indexOf(searchTerm) >= 0) {
              if (!containsFilterTerm) containsFilterTerm = true
            }
          })
          return containsFilterTerm;
        }),
        updated: s.updated + 1
      }))
  }, [searchTerm])

  useEffect(() => {
    setState(
      s => (
        {
          filteredData: state.filteredData.sort((a, b) => {
            if (order == 'desc') {
              return a[orderCol] < b[orderCol] ? -1 : 1
            } else {
              return a[orderCol] < b[orderCol] ? 1 : -1
            }
          }),
          updated: s.updated + 1
        })
    )
  }, [order, orderCol])
  return state
}